<template>
  <div class="emd-table-responsive">
    <Table
      :fields="tableFields"
      :items="items"
      :actions="actions"
    />
  </div>
</template>
<script>
import Table from '@/components/project/molecules/Table.vue'

import { FIELDS } from '../enums/invites-fields.enum'

export default {
  name: 'InvitesTable',
  components: {
    Table
  },

  props: {
    items: Array,
    fields: {
      type: Array,
      default: () => FIELDS
    },
    actions: {
      required: false,
      type: Array,
      default () {
        return []
      }
    }
  },

  computed: {
    tableFields () {
      return this.fields.map(item => ({
        ...item,
        label: this.$t(`invite.${item.label}`),
        text: this.$t(item?.text)
      }))
    }
  }
}
</script>
